import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/hooks/useAuth';
import services from '@/services';
export const useUserQuery = t0 => {
  const $ = _c(11);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    enabled
  } = t1;
  const {
    userId,
    jwt
  } = useAuth();
  let t2;
  if ($[2] !== userId) {
    t2 = ["user", userId];
    $[2] = userId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== jwt || $[5] !== userId) {
    t3 = async () => {
      if (!userId || !jwt) {
        throw new Error("Missing credentials");
      }
      const response = await services.auth.getUserData(userId, jwt);
      if (!response || response.length === 0) {
        throw new Error("User not found");
      }
      return response[0];
    };
    $[4] = jwt;
    $[5] = userId;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = !!userId && !!jwt && (enabled ?? true);
  let t5;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t5 = {
      queryKey: t2,
      queryFn: t3,
      enabled: t4
    };
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return useQuery(t5);
};